import React ,{useState,useEffect}from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import CornerImage from "../../CornerImage/CornerImage";

const HeaderSection = ({ mainImage, title, description, buttonLabel, onButtonClick, direction }) => {
    const [baseURL, setBaseURL] = useState('');
    useEffect(() => {
        // Fetch the config.json to get the baseURL
        const fetchConfig = async () => {
          try {
            const response = await fetch('/config.json');
            const config = await response.json();
            setBaseURL(config.baseURL); 
          } catch (error) {
            console.error('Error fetching config.json:', error);
          }
        };
    
        fetchConfig();
      }, []);
    return (
        <Box
            sx={{
                marginLeft: direction=== "rtl" ? "0px" : { xs: "20px", sm: "40px", md: "90px", xl: "160px" },
                marginRight:  direction=== "rtl" ? { xs: "20px", sm: "40px", md: "90px", xl: "160px" } : "0px",
                direction: direction === "ltr" ? "rtl" : "ltr",
                pt: 2
            }}
            data-aos="fade-up"
        >
            <Grid container spacing={5} alignItems="center" sx={{
                width: "100%", ml: "0px !important",
                pl: "0px !important"
            }}>
                {/* Left Section - Images */}
                <Grid
                    item
                    xs={12}
                    md={7}
                    sx={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        ml: "0px !important",
                        pl: "0px !important"
                    }}
                >
                    <Box className="image-container" sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img
                          
                          src={`${baseURL}/Upload${mainImage}`}
                           loading="lazy"
                            alt="Main" className="main-image"  />
                        <CornerImage position={{ bottom: "3px", left: "1%" }} width="20%" />
                    </Box>

                </Grid>

                {/* Right Section - Content */}
                <Grid item xs={12} md={5} sx={{
                    textAlign: direction === "rtl" ? "right" : "left", ml: "0px !important",
                    pl: "0px !important"
                }}>
                    <Typography sx={{ mb: 1, color: "#12538B", fontWeight: 700, fontSize: "32px" }} data-aos="fade-down">
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            color: "#7B7973",
                            mb: 4,
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            fontSize: "20px",
                            fontWeight: 400,
                            lineHeight: "40px",
                        }}
                    >
                        {description}
                    </Typography>
                    <Box sx={{ direction }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#12538B",
                                borderRadius: "10px",
                                fontSize: "16px",
                                fontWeight: 700,
                                padding: "10px 30px",
                                color: "#fff",
                                "&:hover": { backgroundColor: "#0d406f" },
                                display: "flex",
                                alignItems: "center",
                                flexDirection: direction === "ltr" ? "row-reverse" : "row"
                            }}
                            onClick={onButtonClick}
                        >
                            {buttonLabel}
                            {direction === "ltr" ? (
                                <FaLongArrowAltRight style={{ marginLeft: "16px", fontSize: "20px" }} />
                            ) : (
                                <FaLongArrowAltLeft style={{ marginRight: "16px", fontSize: "20px" }} />
                            )}

                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default HeaderSection;
